import React from 'react'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { normalizeTwoWords, formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";

import './cardLaboratory.scss'
interface CardLaboratoryInter {
  titleDescription: string,
  titleBanner: string,
  typeTitle: string,
  description: any,
  bottonRedirect: any,
  imgUrl: any,
  nombreCategoria: string,
  tituloGeneral: string
}

const CardLaboratory = (props: CardLaboratoryInter) => {
  const {
    titleDescription,
    titleBanner,
    description,
    typeTitle,
    bottonRedirect,
    imgUrl,
    nombreCategoria,
    tituloGeneral
  } = props

  return (
    <div className={`a-card-laboratory gtm${normalizeTwoWords(nombreCategoria)}ClicLaboratorios${normalizeTwoWords(tituloGeneral)}${normalizeTwoWords(titleBanner)}`}>
      <a href={bottonRedirect} rel={findRel(bottonRedirect)}>
        {imgUrl && <img src={imgUrl.file.url} alt={formatImageAlt(imgUrl.title)} className='a-card-laboratory__img' />}

        <div className='a-card-laboratory__description'>
          <h4 className='a-card-laboratory__description-title'>{titleDescription}</h4>
          <h3 className='a-card-laboratory__description-info'>{titleBanner}</h3>
          <div className='a-card-laboratory__description-event'>{documentToReactComponents(description)}</div>

          <div className='icon-arrow-light-right a-card-laboratory__description-arrow'></div>
          <div className='a-card-laboratory__description-back'></div>
        </div>

        <p className='a-card-laboratory__superior'>{typeTitle}</p>
      </a>

    </div>
  )
}

export default CardLaboratory